import React, { useState } from 'react';
import { SERVER_URL } from "../../constants/constants.js";
import { dealjacketActions } from "../../actions";
import { connect } from "react-redux";

import Uploady, { useItemProgressListener } from "@rpldy/uploady";
import { asUploadButton } from "@rpldy/upload-button";
import { Line } from "rc-progress";

function AddonManager(props) {
    const {
        org_id,
        dealjacket_id,
        authentication,
        toggleAddonModal,
        jacketInfo
    } = props;

    const [addonSelected] = useState(false);
    const [uploadComplete, setUploadComplete] = useState(false);

    const refreshUploadComplete = () => {
        setUploadComplete(false);
    }

    const SelectAddonButton = asUploadButton((props) => {
        const { addonSelected } = props;
        return <span {...props} className="classifyFormButton">
            {addonSelected ? 'Change Addon File' : 'Select Addon File'}
        </span>
    });

    const UploadProgress = () => {
        const [uploads, setUploads] = React.useState({});
        const progressData = useItemProgressListener();

        if (progressData && progressData.completed) {

            const upload = uploads[progressData.id] ||
                { name: progressData.url || progressData.file.name, progress: [0] };

            if (!~upload.progress.indexOf(progressData.completed)) {
                upload.progress.push(progressData.completed);

                setUploads({
                    ...uploads,
                    [progressData.id]: upload,
                });
            }
        }

        const entries = Object.entries(uploads);
        if (entries[0] && entries[0][1]?.progress[entries[0][1].progress.length - 1] === 100) {
            setUploadComplete(true);
        }
        return <div>
            {entries
                .map(([id, { progress, name }]) => {
                    const lastProgress = progress[progress.length - 1];

                    return <div key={id}>
                        <Line
                            style={{ height: "10px", marginTop: "20px" }}
                            strokeWidth={3}
                            strokeColor={lastProgress === 100 ? "#3a8562" : "#700382"}
                            percent={lastProgress}
                        />
                        <p>{name}</p>
                    </div>;
                })}
        </div>;
    };
    const jwt = authentication.jwt;
    const upload_url = SERVER_URL + "/org/" + org_id + "/dealjacket/" + dealjacket_id
        + "/addon/review?token=" + jwt;



    return (
        <div className="classifyDeal">
            <div className="classifyForm">
                <form className="ingestorForm">
                    <table className="classifyFormTable">
                        <tbody>
                        <tr><td colSpan="2"><h3>Upload Addon</h3></td></tr>
                        <tr><td colSpan="2"><hr /></td></tr>
                        <tr><td colSpan="2">&nbsp;</td></tr>
                        <tr><td colSpan="2"><b>{jacketInfo.deal_jacket_name}</b></td></tr>
                        <tr><td colSpan="2">&nbsp;</td></tr>
                        <tr><td colSpan="2">currently contains {jacketInfo.pageCount} pages</td></tr>
                        <tr><td colSpan="2">&nbsp;</td></tr>
                        <tr><td colSpan="2"><hr /></td></tr>
                        <tr><td colSpan="2">&nbsp;</td></tr>
                        <tr>
                            <td colSpan="2">
                                {!uploadComplete &&
                                    <Uploady
                                        destination={{ url: upload_url }}>
                                        <SelectAddonButton addonSelected={addonSelected} />
                                        <UploadProgress />
                                    </Uploady>
                                }
                                {
                                    uploadComplete &&
                                    <>
                                        Addon uploaded. Deal resubmitted to ingestion queue.
                                    </>
                                }
                            </td>
                        </tr>
                        <tr><td colSpan="2">&nbsp;</td></tr>
                        <tr><td colSpan="2"><hr /></td></tr>
                        <tr><td colSpan="2">&nbsp;</td></tr>
                        <tr colSpan="2">
                            <td colSpan="2" align="center">
                                {   uploadComplete && 
                                    <span id="refresh" className="classifyFormButton" name="refreshButton" onClick={refreshUploadComplete}>
                                        Upload Another Addon
                                    </span>
                                }

                                <span id="cancel" className="classifyFormButton" name="cancelButton" onClick={toggleAddonModal}>
                                    Cancel
                            </span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </form>
            </div>
        </div>

    );

}

function mapStateToProps(state) {
    const { authentication } = state;
    return {
        authentication,
    };
}

const actionCreators = {
    uploadJacket: dealjacketActions.uploadJacket,
};

const connectedAddonManager = connect(
    mapStateToProps,
    actionCreators
)(AddonManager);
export { connectedAddonManager as AddonManager };